import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const rawg = defineConnector({
  identifier: "rawg",
  name: "RAWG",
  tagLine: "Video game database API",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.rawg\\.io/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a RAWG API key",
      items: [
        {
          kind: "markdown",
          content:
            "Open the RAWG API page, generate an API key, and include it as the `key` query parameter on every request.",
        },
      ],
    },
    {
      title: "Enter your RAWG API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.rawg.io/api/platforms",
  },
});
